<main class="h-dvh overflow-hidden">
  <router-outlet></router-outlet>
</main>
